import { z } from "zod";
import { suffixOptions } from "../Dashboard/constants/suffix";
import { AdvisorId, Organization, Prefix } from "../Types";
export const FartherEmployeeRoles = [
    "FartherAdvisor",
    "CogentAdvisor",
    "WealthPlanAdvisor",
    "ClientServices",
    "Engineering",
    "FartherAdmin",
    "CogentAdmin",
    "WealthPlanAdmin",
    "ServiceTeam",
];
export const FartherOrganizationIntegers = [-1, -2, -3];
export const serviceTeamOptions = [
    "Farther Service Team",
    "Cogent Service Team",
    "WealthPlan Service Team",
];
export const ServiceTeam = z.enum(serviceTeamOptions);
export const serviceTeamAndOrganizationMapping = [
    {
        id: -1,
        organization: Organization.Enum.Farther,
        serviceTeam: ServiceTeam.Enum["Farther Service Team"],
    },
    {
        id: -2,
        organization: Organization.Enum.Cogent,
        serviceTeam: ServiceTeam.Enum["Cogent Service Team"],
    },
    {
        id: -3,
        organization: Organization.Enum.WealthPlan,
        serviceTeam: ServiceTeam.Enum["WealthPlan Service Team"],
    },
];
export const Name = z.object({
    prefix: Prefix.nullable(),
    first: z.string(),
    middle: z.string().nullable(),
    last: z.string(),
    suffix: z.enum(suffixOptions).nullable(),
});
export const Details = z.object({
    isAvailable: z.boolean(),
    isAdmin: z.boolean(),
    headshotPath: z.string().nullable(),
    description: z.string().nullable(),
    calendarUrl: z.string().nullable(),
    linkedinUrl: z.string().nullable(),
    concentration: z.string().nullable(),
    almaMaters: z.string().nullable(),
    hometown: z.string().nullable(),
    experienceStartYear: z.string().nullable(),
    funFacts: z.string().nullable(),
    pershingRrCode: z.string().nullable(),
    location: z.string().nullable(),
});
export const Advisor = z.object({
    advisorId: AdvisorId,
    name: Name,
    emailAddress: z.string(),
    details: Details,
    roles: z.string().array(),
});
export const EmployeeRoleList = [
    "Client Ops",
    "Engineering",
    "Farther Advisor",
    "Farther Admin",
    "Cogent Advisor",
    "Cogent Admin",
    "Service Team",
    "WealthPlan Advisor",
    "WealthPlan Admin",
];
export const EmployeeRole = z.enum(EmployeeRoleList);
export const AdvisorInfoSchema = z.object({
    advisorId: AdvisorId,
    apexAdvisorId: z.number(),
    name: Name,
    fullName: z.string(),
    emailAddress: z.string(),
    details: z.object({
        isAvailable: z.boolean(),
        isAdmin: z.boolean(),
        headshotPath: z.string().nullable(),
        description: z.string().nullable(),
        calendarUrl: z.string().nullable(),
        linkedinUrl: z.string().nullable(),
        concentration: z.string().nullable(),
        almaMaters: z.string().nullable(),
        hometown: z.string().nullable(),
        experienceStartYear: z.string().nullable(),
        funFacts: z.string().nullable(),
        pershingRrCode: z.string().nullable(),
        location: z.string().nullable(),
    }),
    entitlements: z.object({
        isAdvisor: z.boolean(),
        isCx: z.boolean(),
    }),
    roles: EmployeeRole.array(),
});
//# sourceMappingURL=Types.js.map